<template>
  <div class="Disabled">
    <div class="Disabled__isolator"><slot></slot></div>
    <div class="Disabled__overlay">
      <span>Ce champ est à préciser, et viendra dans un second temps.</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "disabled-thing"
};
</script>

<style lang="scss">
.Disabled {
  position: relative;
  //border: 1px solid red;
  &__isolator {
    //border: 1px solid blue;
    opacity: 0.75;
    pointer-events: none;
    & > * {
      pointer-events: none;
    }
  }
  &__overlay {
    pointer-events: none;
    position: absolute;
    top: -3px;
    left: -3px;
    width: calc(100% + 6px);
    height: calc(100% + 6px);
    background: #44444488;
    font-size: 9px;
    font-family: monospace;
    color: white;
    text-shadow: 1px 1px #444444bb;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    span {
      max-width: 30ch;
    }
  }
}
</style>
